/////////////-----------------Login Action------------------///////////
export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_FAIL = "LOGIN_USER_FAIL";

/////////////-----------------verify otp Action------------------///////////
export const VERIFY_OTP = "VERIFY_OTP";
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_FAIL = "VERIFY_OTP_FAIL";

export const CREATE_PASS_SUBADMIN = "CREATE_PASS_SUBADMIN";
export const CREATE_PASS_SUBADMIN_SUCCESS = "CREATE_PASS_SUBADMIN_SUCCESS";
export const CREATE_PASS_SUBADMIN_FAIL = "CREATE_PASS_SUBADMIN_FAIL";

export const SELECT_OTP_OPTION = "SELECT_OTP_OPTION";
export const SELECT_OTP_OPTION_SUCCESS = "SELECT_OTP_OPTION_SUCCESS";
export const SELECT_OTP_OPTION_FAIL = "SELECT_OTP_OPTION_FAIL";
